export const BLUE = '#0b84f3';
export const GREEN = 'rgb(16 171 58)';
